import { gql, QueryHookOptions, useQuery } from '@apollo/client'
import { UserPreviewQuery, UserPreviewQueryVariables } from 'types/graphql'

const userPreviewQuery = gql`
  query userPreview($username: String) {
    user(username: $username) {
      bio
      isSupertester
      username
      fullName
      reviewCount
      createdAt
      location
      verificationStatus
      avatarFullPath
      reviews(take: 4) {
        items {
          brand {
            primaryImageFullPath
            title
          }
        }
      }
    }
  }
`

export const useUserPreview = (options: QueryHookOptions<UserPreviewQuery, UserPreviewQueryVariables>) =>
  useQuery<UserPreviewQuery, UserPreviewQueryVariables>(userPreviewQuery, options)
